import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import {BinGenDocLinkModel} from '../../../../../../models/aggregates/erp/stock';

@Injectable({
  providedIn: 'root'
})
export class BinGenDocLinkService extends BaseApiTemplateService<BinGenDocLinkModel> {

  constructor(http: HttpClient) {
    super();
    this.endpoint_path = `${Core2Config.TENANT_DOMAIN_URL_PREFIX}${Core2Config.ERP_PREFIX}bin/bin-gen-doc-links`;
    this.httpClient = http;
  }

}


